import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { TrueNorthPortraitCardStackBackgroundViewModel } from './true-north-portrait-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-true-north-portrait-card-stack-background',
  templateUrl: './true-north-portrait-card-stack-background.component.html',
  styleUrls: ['./true-north-portrait-card-stack-background.component.scss'],
  providers: [TrueNorthPortraitCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TrueNorthPortraitCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: TrueNorthPortraitCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
